class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

    if (this.classList.contains('header__search')) {
      this.summaryToggle.setAttribute('aria-keyshortcuts', 'Control+K Meta+K');
      this.onKeyboardShortcut = this.onKeyboardShortcut.bind(this);
      document.addEventListener('keydown', this.onKeyboardShortcut);
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onKeyboardShortcut(event) {
    if (event.key.toUpperCase() !== 'K' || !(event.metaKey || event.ctrlKey)) return;

    const { activeElement } = document;
    const isTyping =
      activeElement &&
      (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable);
    if (isTyping && !this.contains(activeElement)) return;

    event.preventDefault();
    this.summaryToggle.click();
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  populateSearchContent(event) {
    const recentlyViewed = this.detailsContainer.querySelector('.predictive-search-recently-viewed');
    if (recentlyViewed) {
      if (recentlyViewed.classList.contains('hidden') | recentlyViewed.classList.contains('rendered')) {
        return;
      }
      const html = window.renderRecentlyViewed(4);
      if (html === '') {
        recentlyViewed.classList.add('hidden');
        return;
      }
      recentlyViewed.classList.add('rendered');
      recentlyViewed.querySelector('.recently-viewed-products')?.insertAdjacentHTML('beforeend', html);
    }

  }

  open(event) {
    this.populateSearchContent(event);


    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    document.body.setAttribute('modal-opening', true);
    setTimeout(() => document.body.removeAttribute('modal-opening'), 500);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
